import styled from "styled-components";
import { SwipeableDrawer } from "@mui/material";

/* Bottom sheet padrão do app: sobe de baixo como nos apps nativos e fecha
   arrastando para baixo ou tocando fora */
export const Sheet = styled(SwipeableDrawer)`
  & .MuiDrawer-paper {
    width: 100%;
    max-width: 480px;
    max-height: 90vh;
    max-height: 90dvh;
    margin: 0 auto;
    border-radius: 20px 20px 0 0;
    overflow-y: auto;
    box-sizing: border-box;
    padding: 0 20px calc(16px + env(safe-area-inset-bottom));
  }
`;

export const Handle = styled.div`
  width: 40px;
  height: 5px;
  border-radius: 3px;
  background-color: #dddddd;
  margin: 10px auto 16px;
  flex-shrink: 0;
`;
